import { render, staticRenderFns } from "./BannerDiscountTransportTemplateBlock.vue?vue&type=template&id=65eeada9&scoped=true&"
import script from "./BannerDiscountTransportTemplateBlock.vue?vue&type=script&lang=js&"
export * from "./BannerDiscountTransportTemplateBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerDiscountTransportTemplateBlock.vue?vue&type=style&index=0&id=65eeada9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eeada9",
  null
  
)

export default component.exports